/* ============================================================
   ประวัติการเข้าหน้าล่าสุด (ทางลัด) ของแต่ละผู้ใช้งาน
   - เก็บใน cookie แยกตาม userId อายุ 90 วัน
   - เก็บสูงสุด 6 รายการ ใหม่สุดอยู่หน้าสุด
   - ถ้าเข้าหน้าซ้ำ ให้ย้ายขึ้นมาอันที่ 1
============================================================ */
const MAX_RECENT = 6;
const DAYS = 90;

const keyOf = (userId) => `nsf_recent_${userId || "guest"}`;

const readCookie = (name) => {
  if (typeof document === "undefined") return "";
  const hit = (document.cookie ? document.cookie.split("; ") : []).find((c) =>
    c.startsWith(`${name}=`)
  );
  return hit ? decodeURIComponent(hit.split("=").slice(1).join("=")) : "";
};

const writeCookie = (name, value) => {
  if (typeof document === "undefined") return;
  const expires = new Date(Date.now() + DAYS * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/; SameSite=Lax`;
};

export const getRecent = (userId) => {
  try {
    const raw = readCookie(keyOf(userId));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.slice(0, MAX_RECENT) : [];
  } catch (e) {
    return [];
  }
};

export const pushRecent = (userId, item) => {
  if (!item || !item.to) return getRecent(userId);
  const list = getRecent(userId).filter((r) => r.to !== item.to);
  list.unshift({ title: item.title, to: item.to });
  const capped = list.slice(0, MAX_RECENT);
  try {
    writeCookie(keyOf(userId), JSON.stringify(capped));
  } catch (e) {
    /* ignore */
  }
  return capped;
};

export const clearRecent = (userId) => {
  writeCookie(keyOf(userId), JSON.stringify([]));
  return [];
};
